import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';

const fetchUtils = new FetchUtils();
const baseUrl = getBackendUri();

export interface G2ReviewTokenResponse {
	state?: string;
	reviewExists?: boolean;
}

export const fetchG2ReviewToken =
	(userType: string, email: string) =>
	(dispatch: any): Promise<G2ReviewTokenResponse> => {
		return fetchUtils
			.post(baseUrl + `/api/v1/${userType}/g2/review_token`, {
				data: { email },
			})
			.then(parseJSON)
			.then((response) => {
				if (response.ok) {
					return response.json;
				}
				throw new Error('Failed to fetch G2 review token');
			});
	};
